import { render, staticRenderFns } from "./ManualsTab.vue?vue&type=template&id=125baea0&scoped=true"
import script from "./ManualsTab.vue?vue&type=script&lang=js"
export * from "./ManualsTab.vue?vue&type=script&lang=js"
import style0 from "./ManualsTab.vue?vue&type=style&index=0&id=125baea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125baea0",
  null
  
)

export default component.exports